(function () {
    const initProgressiveLoad = function () {
        const feeds = document.querySelectorAll('.gh-progressive-feed');
        
        feeds.forEach(feed => {
            if (feed.dataset.progressiveInitialized) return;
            feed.dataset.progressiveInitialized = true;

            // 1. Capture and detach all items
            // We assume direct children are the items to be paginated
            const allItems = Array.from(feed.children).filter(el => !el.classList.contains('gh-sentinel'));
            
            // If no items, do nothing
            if (allItems.length === 0) return;

            // Remove items from DOM
            allItems.forEach(item => item.remove());

            // Handle Recommendation Mode (Random Shuffle)
            const recMode = feed.dataset.recommendationMode;
            if (recMode === "Random") {
                for (let i = allItems.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [allItems[i], allItems[j]] = [allItems[j], allItems[i]];
                }
            }

            // Create or reuse sentinel
            let sentinel = feed.querySelector('.gh-sentinel');
            if (!sentinel) {
                sentinel = document.createElement('div');
                sentinel.className = 'gh-sentinel';
                // Style sentinel to be invisible but take up space/trigger observer
                sentinel.style.height = '1px';
                sentinel.style.width = '100%';
                sentinel.style.marginTop = '20px';
                feed.appendChild(sentinel);
            }

            let currentIndex = 0;
            const batchSize = 12; // Standard batch size

            // 2. Progressive Rendering Logic
            function renderBatch() {
                const batch = allItems.slice(currentIndex, currentIndex + batchSize);
                if (batch.length === 0) {
                    sentinel.style.display = 'none';
                    return;
                }

                const fragment = document.createDocumentFragment();
                batch.forEach(item => fragment.appendChild(item));

                feed.insertBefore(fragment, sentinel);

                currentIndex += batchSize;

                // Hide sentinel if no more items
                if (currentIndex >= allItems.length) {
                    sentinel.style.display = 'none';
                } else {
                    sentinel.style.display = 'block';
                }
            }

            // 3. Intersection Observer
            const observer = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && currentIndex < allItems.length) {
                    renderBatch();
                }
            }, { rootMargin: '300px' }); // Preload before hitting bottom

            observer.observe(sentinel);

            // Initial render
            renderBatch();
        });
    };

    // Initialize on load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initProgressiveLoad);
    } else {
        initProgressiveLoad();
    }

    // Export for manual re-init if needed (optional)
    window.initProgressiveLoad = initProgressiveLoad;
})();
